/* The Afnan Tour × Ed Westwick: behaviour for sections/afnan-tour.liquid (styles: assets/aftour.css).
   Ported from the standalone site. Data (cities, strings in the storefront language, city, API URL)
   comes from the JSON that snippets/afnan-tour-data.liquid prints inside the section. */
(() => {
  const root = document.getElementById("aftour-root");
  const dataEl = document.getElementById("aftour-data");
  if (!root || !dataEl) return;
  const D = JSON.parse(dataEl.textContent);
  const CITIES = D.cities, T = D.t, slug = D.city, ENDPOINT = D.endpoint, WINNERS = 5;
  const C = CITIES[slug];
  const $ = id => document.getElementById("aftour-" + id);

  // Dates and country names follow the storefront language; the city's own locale when they match.
  const lang = (D.lang || "en").slice(0, 2);
  const LOCALE = lang === C.lang ? C.locale : ({ en: "en-GB", es: "es-419", pt: "pt-BR" }[lang] || D.lang);
  const t = (key, vars = {}) => (T[key] ?? key).replace(/\{(\w+)\}/g, (m, k) => k in vars ? vars[k] : m);
  const day = (iso, opts) => new Date(iso + "T12:00:00Z").toLocaleDateString(LOCALE, { timeZone: "UTC", ...opts });
  const long = iso => day(iso, { day: "numeric", month: "long", year: "numeric" });
  const fill = (k, v) => root.querySelectorAll(`[data-${k}]`).forEach(el => el.textContent = v);
  const regionName = new Intl.DisplayNames([LOCALE], { type: "region" });
  const countryName = c => regionName.of(c.cc) || c.country;
  const cityName = t("city." + slug);
  // starts the hero line, so capitalise it (Spanish/Portuguese weekdays are lowercase)
  const cap = str => str.charAt(0).toLocaleUpperCase(LOCALE) + str.slice(1);

  fill("city", cityName); fill("country", countryName(C)); fill("winners", WINNERS);
  fill("eventlong", cap(day(C.event, { weekday: "long", day: "numeric", month: "long" })));
  fill("eventshort", day(C.event, { day: "numeric", month: "short" }));
  fill("draw", long(C.draw)); fill("notify", long(C.notify)); fill("closelong", long(C.close.slice(0, 10)));

  // country → city dropdowns: defaults to this page's country and event city (first in every list)
  const countrySel = $("country"), citySel = $("city"), cityOther = $("cityOther");
  const byCountry = Object.fromEntries(Object.values(CITIES).map(c => [c.country, c]));
  countrySel.innerHTML = `<option class="aftour-t aftour-opt" value="${C.country}">${countryName(C)}</option>`; // fixed: each page is for one country, only the city is chosen
  countrySel.value = C.country; countrySel.setAttribute("aria-readonly", "true");
  const setCountry = () => {
    const c = byCountry[countrySel.value];
    citySel.innerHTML = c.cities.map(n => `<option class="aftour-t aftour-opt">${n}</option>`).join("") + `<option class="aftour-t aftour-opt" value="__other">${t("form.city.other")}</option>`;
    citySel.selectedIndex = 0; citySel.onchange();
    $("whatsapp").placeholder = c.dial + " 999 999 999";
  };
  countrySel.onchange = setCountry;
  citySel.onchange = () => {
    cityOther.hidden = citySel.value !== "__other"; cityOther.required = !cityOther.hidden;
    if (!cityOther.hidden) cityOther.focus();
  };
  setCountry();

  const mq = '<span class="aftour-t aftour-marquee__item">Night Out</span><span class="aftour-t aftour-marquee__item aftour-marquee__item--alt">Own Your Moment</span>'.repeat(4);
  $("marquee").innerHTML = mq + mq;

  // hero: size the city by its longest word
  root.style.setProperty("--n", Math.max(...cityName.split(" ").map(w => w.length), 4));

  // product: shop now where the store is live (cities.json "shop" + "store" URL), otherwise coming soon
  const store = $("storeBtn"), canShop = C.shop && C.store, mode = canShop ? "shop" : "soon";
  $("productTitle").textContent = t(`product.${mode}.title`);
  $("productTag").textContent = t(`product.${mode}.tag`, { country: countryName(C) });
  $("productLead").textContent = t(`product.${mode}.lead`, { country: countryName(C) });
  store.textContent = t(`product.${mode}.button`);
  if (canShop) store.href = C.store;
  else { store.classList.add("aftour-ghost"); store.setAttribute("aria-disabled", "true"); store.style.pointerEvents = "none"; }

  // countdown
  const end = new Date(C.close).getTime();
  const cd = Object.fromEntries([...$("cd").querySelectorAll("[data-u]")].map(b => [b.dataset.u, b]));
  const pad = n => String(n).padStart(2, "0");
  (function tick() {
    const s = Math.max(0, end - Date.now()) / 1000;
    if (s <= 0) { root.classList.add("aftour-is-closed"); return; }
    cd.d.textContent = pad(Math.floor(s / 86400)); cd.h.textContent = pad(Math.floor(s % 86400 / 3600));
    cd.m.textContent = pad(Math.floor(s % 3600 / 60)); cd.s.textContent = pad(Math.floor(s % 60));
    setTimeout(tick, 1000);
  })();

  // form
  const form = $("form"), s1 = $("step1"), s2 = $("step2");
  const step = n => {
    s1.hidden = n !== 1; s2.hidden = n !== 2;
    $("s2").classList.toggle("aftour-on", n === 2);
    (n === 2 ? s2 : s1).querySelector("input").focus({ preventScroll: true });
  };
  const check = input => {
    const v = input.value.trim(); input.value = v;
    const ok = input.checkValidity() && (input.name !== "name" || v.length > 1);
    input.setAttribute("aria-invalid", !ok); return ok;
  };
  const fields = () => [...s1.querySelectorAll("input, select")].filter(i => !i.hidden && i.name !== "company");
  fields().concat(cityOther).forEach(i => i.addEventListener("blur", () => i.value && check(i)));
  $("next").onclick = () => {
    const bad = fields().filter(i => !check(i));
    bad.length ? bad[0].focus() : step(2);
  };
  $("back").onclick = () => step(1);

  form.onsubmit = async e => {
    e.preventDefault();
    const consent = $("consent");
    $("consentErr").classList.toggle("aftour-show", !consent.checked);
    if (!consent.checked || Date.now() > end) return;
    const btn = $("submit"), err = $("submitErr");
    const data = { ...Object.fromEntries(new FormData(form)), citySlug: slug };
    if (data.city === "__other") data.city = data.cityOther;
    delete data.cityOther;
    btn.disabled = true; btn.textContent = t("form.submitting"); err.textContent = "";
    try {
      const r = await fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) });
      const res = await r.json().catch(() => ({}));
      // the API sends an error code; show it in this page's language
      if (!r.ok) throw new Error(t(("error." + res.code) in T ? "error." + res.code : "error.generic", { city: cityName }));
      form.hidden = true;
      const done = $("done"); done.hidden = false; done.focus();
    } catch (x) {
      err.textContent = x instanceof TypeError ? t("error.connection") : x.message;
      btn.disabled = false; btn.textContent = t("form.submit");
    }
  };

  // share: this page's own address on the store
  const link = location.origin + location.pathname;
  const msg = t("share.message", { city: cityName, link });
  $("shareWa").href = "https://wa.me/?text=" + encodeURIComponent(msg);
  const copy = async btn => { try { await navigator.clipboard.writeText(link); btn.textContent = t("share.copied"); } catch { prompt(t("share.prompt"), link); } };
  $("copy").onclick = e => copy(e.currentTarget);
  // Web can't post to an IG story directly; native share sheet on mobile, copy link elsewhere.
  $("shareIg").onclick = e => navigator.share ? navigator.share({ title: "The Afnan Tour", text: msg, url: link }).catch(() => {}) : copy(e.currentTarget);

  // privacy links open the city's notice in a popup (plain link still works without <dialog>)
  const pm = $("privacy"), pmFrame = pm.querySelector("iframe");
  root.addEventListener("click", e => {
    const a = e.target.closest('a[href*="/privacy/"]');
    if (!a || !pm.showModal) return;
    e.preventDefault();
    pmFrame.title = a.textContent;
    if (pmFrame.dataset.src !== a.href) { pmFrame.dataset.src = a.href; pmFrame.src = a.href + "?embed"; } // load once
    pm.showModal();
  });
  pm.querySelector(".aftour-modal__close").onclick = () => pm.close();
  pm.addEventListener("click", e => { if (e.target === pm) pm.close(); }); // click on the backdrop

  // scroll reveal + sticky bar (hidden over hero, form and product, so it never covers their buttons)
  const io = new IntersectionObserver(es => es.forEach(x => x.isIntersecting && (x.target.classList.add("aftour-in"), io.unobserve(x.target))), { threshold: .15 });
  root.querySelectorAll(".aftour-rv").forEach(el => io.observe(el));
  const sticky = $("sticky"), seen = new Set();
  const so = new IntersectionObserver(es => {
    es.forEach(x => x.isIntersecting ? seen.add(x.target) : seen.delete(x.target));
    sticky.classList.toggle("aftour-show", seen.size === 0);
  });
  ["hero", "enter", "product"].forEach(id => so.observe($(id)));
})();
